<script>
import Slider from '@vueform/slider'
import _ from 'lodash'
import {mapState} from 'pinia'
import {useApplicationStore} from '@stores/application.store'

export default {
  name: 'ListMenu',

  components: {
    Slider,
  },

  inject: {
    'standardList': {
      from: 'standardList',
    },
  },

  emits: [
    'menu-toggled',
    'menu-submitted',
  ],

  data () {
    return {
      // * * * ui * * *
      // activeMenu
      // - sort
      // - brand
      // - condition
      // - substation
      activeMenu: null,
      // showMenu show menu,
      // control if show menu
      showMenu: false,
      // * * * options * * *
      // optionOfSort
      optionOfSort: [],
      // optionOfBrand
      optionOfBrand: [],
      // optionOfProvince
      optionOfProvince: [],
      // optionOfEmission
      optionOfEmission: [],
      // optionOfHot
      optionOfHot: [],
      // optionOfSeat
      optionOfSeat: [],
      // optionOfShape
      optionOfShape: [],
      // optionOfSubstation
      optionOfSubstation: [],
      // optionOfDriveMode
      optionOfDriveMode: [],
      // optionOfEnergyType
      // - 2024.10.14
      optionOfEnergyType: [],

      // optionOfIsRentingBattery
      // - 2024.10.14
      optionOfIsRentingBattery: [],

      // optionOfVehicleRating
      optionOfVehicleRating: [],

      // * * * conditions  * * *
      // sort
      sort: [],
      // brand
      brand: [],
      // province
      province: [],
      // emission
      emission: [],
      // hot
      hot: [],
      // shape
      shape: [],
      // seat,
      seat: [],
      // substation
      substation: [],
      // driveMode
      // - 2024.02.22
      driveMode: [],
      // price range
      // - 2024.02.22
      modelOfPriceRange: [0, 50],
      // - energyType
      // - 2024.10.14
      energyType: [],
      // - isRentingBattery
      // - 2024.10.14
      isRentingBattery: [],
      // vehicleRating
      // - 2025.02.11
      vehicleRating: [],
    }
  },

  computed: {
    ...mapState(useApplicationStore, [
      'wework',
    ]),

    // outputOfPriceRange
    outputOfPriceRange () {
      const [min, max] = this.modelOfPriceRange

      this.standardList.updateMinValueOfPriceRange(min === 0 ? null : min)
      this.standardList.updateMaxValueOfPriceRange(max === 50 ? null : max)

      if (min === 0 && max === 50) {
        return '不限'
      }
      else if (min === 0 && max !== 50) {
        return `${max}万元以下`
      }
      else if (min !== 0 && max === 50) {
        return `${min}万元以上`
      }
      else {
        return `${min}–${max}万元`
      }
    },

    // brandUniqByName
    // - 2024.06.05
    brandUniqByName () {
      return _
        .chain(this.brand)
        .cloneDeep()
        .uniqBy('name')
        .value()
    },
  },

  // created
  async created () {
    // options used in menu
    await this.standardList.init()

    this.optionOfSort = this.standardList.optionOfSort
    this.optionOfBrand = this.standardList.optionOfBrand
    this.optionOfProvince = this.standardList.optionOfProvince
    this.optionOfEmission = this.standardList.optionOfEmission
    this.optionOfHot = this.standardList.optionOfHot
    this.optionOfSeat = this.standardList.optionOfSeat
    this.optionOfShape = this.standardList.optionOfShape
    this.optionOfSubstation = this.standardList.optionOfSubstation
    this.optionOfDriveMode = this.standardList.optionOfDriveMode
    this.optionOfEnergyType = this.standardList.optionOfEnergyType
    this.optionOfIsRentingBattery = this.standardList.optionOfIsRentingBattery
    this.optionOfVehicleRating = this.standardList.optionOfVehicleRating
  },

  // methods
  methods: {
    // toggleMenu toogle menu
    // menu hd item, close btn in menu body
    toggleMenu (e) {
      const {menu} = e.currentTarget.dataset

      if (menu === this.activeMenu) {
        this.showMenu = false
        this.activeMenu = null
        this.$emit('menu-toggled', {
          show: false,
        })
      }
      else {
        this.showMenu = true
        this.activeMenu = menu
        this.$emit('menu-toggled', {
          show: true,
        })
      }
    },

    // optionOfSortDidPress options of sort did press
    optionOfSortDidPress (e, option) {
      this.standardList.updateOptionOfSort(option)
      this.optionOfSort = this.standardList.optionOfSort
      this.submit()
    },

    // optionOfBrandDidPress option of brand did press
    optionOfBrandDidPress (e, option) {
      this.standardList.updateOptionOfBrand(option)
      this.standardList.autoAddNewEnergy()

      this.optionOfBrand = this.standardList.optionOfBrand
      this.optionOfHot = this.standardList.optionOfHot
    },

    // clearSelectionOfBrandBtnDidPress
    // clear selection of brand btn did press
    clearSelectionOfBrandBtnDidPress () {
      this.standardList.resetOptionOfBrand()
      this.optionOfBrand = this.standardList.optionOfBrand

      this.submit()
    },

    // submitBrandBtnDidPress
    // submit brand btn did press
    submitBrandBtnDidPress () {
      this.submit()
    },

    // optionOfProvinceDidPress
    optionOfProvinceDidPress (e, option) {
      this.standardList.updateOptionOfProvince(option)
      this.optionOfProvince = this.standardList.optionOfProvince
    },

    // optionOfEmissionDidPress
    optionOfEmissionDidPress (e, option) {
      this.standardList.updateOptionOfEmission(option)
      this.optionOfEmission = this.standardList.optionOfEmission
    },

    // optionOfHotDidPress
    optionOfHotDidPress (e, option) {
      this.standardList.updateOptionOfHot(option)
      this.optionOfHot = this.standardList.optionOfHot
    },

    // optionOfSeatDidPress
    optionOfSeatDidPress (e, option) {
      this.standardList.updateOptionOfSeat(option)
      this.optionOfSeat = this.standardList.optionOfSeat
    },

    // optionOfShapeDidPress
    optionOfShapeDidPress (e, option) {
      this.standardList.updateOptionOfShape(option)
      this.optionOfShape = this.standardList.optionOfShape
    },

    // optionOfDriveModeDidPress
    optionOfDriveModeDidPress (e, option) {
      this.standardList.updateOptionOfDriveMode(option)
      this.optionOfDriveMode = this.standardList.optionOfDriveMode
    },

    // optionOfEnergyTypeDidPress
    optionOfEnergyTypeDidPress (e, option) {
      this.standardList.updateOptionOfEnergyType(option)
      this.optionOfEnergyType = this.standardList.optionOfEnergyType
    },

    // optionOfIsRentingBatteryDidPress
    optionOfIsRentingBatteryDidPress (e, option) {
      this.standardList.updateOptionOfIsRentingBattery(option)
      this.optionOfIsRentingBattery = this.standardList.optionOfIsRentingBattery
    },

    // optionOfVehicleRatingDidPress
    optionOfVehicleRatingDidPress (e, option) {
      this.standardList.updateOptionOfVehicleRating(option)
      this.optionOfVehicleRating = this.standardList.optionOfVehicleRating
    },

    // optionOfShapeDidPress
    async optionOfSubstationDidPress (e, option) {
      this.standardList.updateOptionOfSubstation(option, false)
      this.optionOfSubstation = this.standardList.optionOfSubstation
      await this.standardList.loadBrandBySubstation()

      this.optionOfBrand = this.standardList.optionOfBrand
    },

    // clearSelectionOfConditionBtnDidPress
    clearSelectionOfConditionBtnDidPress () {
      this.standardList.resetOptionOfConditions()

      this.optionOfProvince = this.standardList.optionOfProvince
      this.optionOfEmission = this.standardList.optionOfEmission
      this.optionOfHot = this.standardList.optionOfHot
      this.optionOfSeat = this.standardList.optionOfSeat
      this.optionOfShape = this.standardList.optionOfShape
      this.optionOfDriveMode = this.standardList.optionOfDriveMode
      this.modelOfPriceRange = [0, 50]
      this.optionOfEnergyType = this.standardList.optionOfEnergyType
      this.optionOfIsRentingBattery = this.standardList.optionOfIsRentingBattery
      this.optionOfVehicleRating = this.standardList.optionOfVehicleRating

      this.submit()
    },

    // submitConditionBtnDidPress
    submitConditionBtnDidPress () {
      this.submit()
    },

    // optionOfSelectedBrandDidPress
    // - 2024.06.05
    // - Option of selected brand did press
    optionOfSelectedBrandDidPress (e, option) {
      this.standardList.setOptionOfBrandToFalseByBrandName(option)
      this.optionOfBrand = this.standardList.optionOfBrand

      this.submit()
    },

    // optionOfSelectedProvinceDidPress
    optionOfSelectedProvinceDidPress (e, option) {
      this.standardList.updateOptionOfProvince(option)
      this.optionOfBrand = this.standardList.optionOfProvince

      this.submit()
    },

    // optionOfSelectedEmissionDidPress
    optionOfSelectedEmissionDidPress (e, option) {
      this.standardList.updateOptionOfEmission(option)
      this.optionOfEmission = this.standardList.optionOfEmission

      this.submit()
    },

    // optionOfSelectedHotDidPress
    optionOfSelectedHotDidPress (e, option) {
      this.standardList.updateOptionOfHot(option)
      this.optionOfHot = this.standardList.optionOfHot

      this.submit()
    },

    // optionOfSelectedSeatDidPress
    optionOfSelectedSeatDidPress (e, option) {
      this.standardList.updateOptionOfSeat(option)
      this.optionOfSeat = this.standardList.optionOfSeat

      this.submit()
    },

    // optionOfSelectedShapeDidPress
    optionOfSelectedShapeDidPress (e, option) {
      this.standardList.updateOptionOfShape(option)
      this.optionOfShape = this.standardList.optionOfShape

      this.submit()
    },

    // optionOfSelectedPriceRangeDidPress
    optionOfSelectedPriceRangeDidPress () {
      this.standardList.updateMinValueOfPriceRange(null)
      this.standardList.updateMaxValueOfPriceRange(null)
      this.modelOfPriceRange = [
        0,
        50,
      ]

      this.$emit('menu-submitted')
    },

    // optionOfSelectedEnergyTypeDidPress
    optionOfSelectedEnergyTypeDidPress (e, option) {
      this.standardList.updateOptionOfEnergyType(option)
      this.optionOfEnergyType = this.standardList.optionOfEnergyType
      this.submit()
    },

    // optionOfSelectedIsRentingBatteryDidPress
    optionOfSelectedIsRentingBatteryDidPress (e, option) {
      this.standardList.updateOptionOfIsRentingBattery(option)
      this.optionOfIsRentingBattery = this.standardList.optionOfIsRentingBattery
      this.submit()
    },

    // optionOfSelectedVehicleRatingDidPress
    optionOfSelectedVehicleRatingDidPress (e, option) {
      this.standardList.updateOptionOfVehicleRating(option)
      this.optionOfVehicleRating = this.standardList.optionOfVehicleRating
      this.submit()
    },

    // submit
    // - 2023.08.15
    submit () {
      this.sort = this.standardList.sort
      this.brand = this.standardList.brand
      this.province = this.standardList.province
      this.emission = this.standardList.emission
      this.hot = this.standardList.hot
      this.seat = this.standardList.seat
      this.hot = this.standardList.hot
      this.shape = this.standardList.shape
      this.seat = this.standardList.seat
      this.substation = this.standardList.substation
      this.driveMode = this.standardList.driveMode
      this.energyType = this.standardList.energyType
      this.isRentingBattery = this.standardList.isRentingBattery
      this.vehicleRating = this.standardList.vehicleRating

      this.showMenu = false
      this.activeMenu = null
      this.$emit('menu-submitted')
    },

    // resetSubstationBtnDidPress
    // - 2023.08.15
    // - clear substation btn did press
    resetSubstationBtnDidPress () {
      this.standardList.resetoptionOfSubstation()
      this.standardList.loadBrandBySubstation()

      this.optionOfSubstation = this.standardList.optionOfSubstation
      this.substation = this.standardList.substation

      this.submit()
    },

    // submitSubstationBtnDidPress
    // - 2023.08.15
    // - submit substation btn did press
    submitSubstationBtnDidPress () {
      this.standardList.loadBrandBySubstation()
      this.optionOfBrand = this.standardList.optionOfBrand
      this.optionOfSubstation = this.standardList.optionOfSubstation
      this.substation = this.standardList.substation

      this.submit()
    },

    // optionOfSelectedSubstationDidPress
    // - 2023.08.16
    // - option of selected substation did press
    optionOfSelectedSubstationDidPress (e, option) {
      this.standardList.updateOptionOfSubstation(option)
      this.optionOfSubstation = this.standardList.optionOfSubstation

      this.submit()
    },

    // optionOfSelectedDriveModeidPress
    optionOfSelectedDriveModeidPress (e, option) {
      this.standardList.updateOptionOfDriveMode(option)
      this.optionOfDriveMode = this.standardList.optionOfDriveMode

      this.submit()
    },
  },
}
</script>

<template>
  <!-- menu START -->
  <div
    class="menu"
    v-bind="$attrs">
    <div class="menu-hd">
      <!-- menu hd sort -->
      <div class="menu-hd-item-wrapper">
        <div
          :class="[
            'menu-hd-item',
            activeMenu === 'sort' ? 'menu-hd-item--active' : '',
            standardList
              && standardList.sort[0]
              && standardList.sort[0].name
              && standardList.sort[0].name !== standardList.optionOfSort[0].name
              ? 'menu-hd-item--not-default' : ''
          ]"
          :data-menu="'sort'"
          @click.prevent="toggleMenu">
          <span :class="['menu-hd-item-text',]">
            {{
              standardList
                && standardList.sort[0]
                ? standardList.sort[0].name
                : ""
            }}
          </span>
          <span :class="['menu-hd-item-indicator']" />
        </div>
      </div>
      <!--/  menu hd sort -->
      <!-- menu hd brand  -->
      <div class="menu-hd-item-wrapper">
        <div
          :class="[
            'menu-hd-item',
            activeMenu === 'brand' ? 'menu-hd-item--active' : '',
          ]"
          :data-menu="'brand'"
          @click.prevent="toggleMenu">
          <span :class="['menu-hd-item-text']">品牌</span>
          <span :class="['menu-hd-item-indicator']" />
        </div>
      </div>
      <!--/ menu hd brand -->
      <!-- menu hd condition -->
      <div class="menu-hd-item-wrapper">
        <div
          :class="[
            'menu-hd-item',
            activeMenu === 'condition' ? 'menu-hd-item--active' : '',
          ]"
          :data-menu="'condition'"
          @click.prevent="toggleMenu">
          <span :class="['menu-hd-item-text']">筛选</span>
          <span :class="['menu-hd-item-indicator']" />
        </div>
      </div>
      <!--/ menu hd condition -->
      <!-- menu hd substation -->
      <div class="menu-hd-item-wrapper">
        <div
          :class="[
            'menu-hd-item',
            activeMenu === 'substation' ? 'menu-hd-item--active' : '',
            standardList
              && standardList.substation[0]
              && standardList.substation[0].name
              && standardList.substation[0].name !== standardList.optionOfSubstation[0].name
              ? 'menu-hd-item--not-default' : ''
          ]"
          :data-menu="'substation'"
          @click.prevent="toggleMenu">
          <span :class="['menu-hd-item-text']">
            分站
          </span>
          <span :class="['menu-hd-item-indicator']" />
        </div>
      </div>
      <!--/ menu hd substation -->
    </div>

    <!-- menu-bd -->
    <div
      v-show="showMenu"
      :class="['menu-bd-wrapper']">
      <!-- sort -->
      <div
        v-show="activeMenu === 'sort'"
        class="menu-section-wrapper">
        <div class="menu-section">
          <div class="menu-section-hd">
            <div class="menu-section-title">请选择排序</div>
          </div>
          <div class="menu-section-bd">
            <div class="menu-group sort-menu-group">
              <div class="menu-group-bd sort-menu-group-bd">
                <template
                  v-for="(option, optionIndex) in optionOfSort"
                  :key="optionIndex">
                  <div
                    :class="[
                      'menu-group-item',
                      'menu-group-item-sort',
                      option.enable ? 'enabled' : '',
                    ]"
                    @click.prevent.stop="optionOfSortDidPress($event, option)">
                    {{ option.name }}
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="menu-section-ft">
            <div class="action-btn-wrapper">
              <div
                :class="['menu-btn', 'menu-close-btn']"
                :data-menu="'sort'"
                @click.prevent.stop="toggleMenu">
                关闭
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--/ sort -->

      <!-- brand -->
      <div
        v-show="activeMenu === 'brand'"
        class="menu-section-wrapper">
        <div class="menu-section">
          <div class="menu-section-hd">
            <div class="brand__selected-substations-wrapper">
              <!-- <div class="menu-section-title">请选择品牌（多选）</div> -->
              <div class="menu-section-title">
                <span style="margin-right: 5px;">当前展示分站为</span>
                <template v-if=" standardList.substation && standardList.substation.length ">
                  <template
                    v-for="(station, stationIndex) in standardList.substation"
                    :key="stationIndex">
                    <span class="selected-brand-item">
                      <template v-if="station.name === '上海站（集团总部）'">
                        上海站
                      </template>
                      <template v-else-if="station.name === '成都站（西南中心站）'">
                        成都站
                      </template>
                      <template v-else>
                        {{ station.name }}
                      </template>
                    </span>
                  </template>
                </template>
                <template v-else>
                  <span class="selected-brand-item">全部分站</span>
                </template>
              </div>
            </div>
          </div>
          <div class="menu-section-bd">
            <div class="menu-group">
              <div class="menu-group-hd" />
              <div class="menu-group-bd menu-group-bd--brand">
                <template
                  v-for="(brandGroup, brandGroupIndex) in optionOfBrand"
                  :key="brandGroupIndex">
                  <template v-if="brandGroup.items && brandGroup.items.length">
                    <div class="brand-group-wrapper">
                      <div class="brand-group-hd">
                        <div class="brand-group-title">
                          {{ brandGroup.name }}
                        </div>
                      </div>
                      <div class="brand-group-bd">
                        <template
                          v-for="(brandItem, brandItemIndex) in brandGroup.items"
                          :key="brandItemIndex">
                          <div
                            :class="[
                              'menu-group-item',
                              'menu-group-item--brand',
                              brandItem.enable === true ? 'enabled' : '',
                            ]"
                            @click.prevent.stop="optionOfBrandDidPress($event, brandItem)">
                            <template v-if="brandGroup.name === '新能源'">
                              <div class="menu-group-item--brand__icon--new-energy" />
                            </template>
                            <div
                              class="brand-item-pic-wrapper">
                              <img
                                :class="['brand-item-pic']"
                                :src="brandItem.logo">
                            </div>
                            <div class="brand-item-name-wrapper">
                              <span class="brand-item-name__text">{{ brandItem.name }}</span>
                              <template v-if="wework">
                                <span class="brand-item-name__count">({{ brandItem.num }})</span>
                              </template>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
            </div>
          </div>
          <div class="menu-section-ft">
            <div class="action-btn-wrapper">
              <div
                :class="['menu-btn', 'menu-close-btn']"
                :data-menu="'brand'"
                @click.prevent.stop="toggleMenu">
                关闭
              </div>
              <div
                :class="['menu-btn', 'menu-clear-btn']"
                @click.prevent.stop="clearSelectionOfBrandBtnDidPress">
                重置品牌
              </div>
              <div
                :class="['menu-btn', 'menu-submit-btn']"
                @click.prevent.stop="submitBrandBtnDidPress">
                确认提交
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--/ brand -->

      <!-- condition -->
      <div
        v-show="activeMenu === 'condition'"
        class="menu-section-wrapper menu-section-wrapper--condition">
        <div class="menu-section">
          <div class="menu-section-hd">
            <div class="menu-section-title">请选择条件（多选）</div>
          </div>
          <div class="menu-section-bd">
            <!-- 热门类型 -->
            <div class="menu-group condition-group">
              <div class="menu-group-hd">
                <div class="menu-group-title">热门类型</div>
              </div>
              <div class="menu-group-bd">
                <template
                  v-for="(option, optionIndex) in optionOfHot"
                  :key="optionIndex">
                  <div
                    :class="[
                      'menu-group-item',
                      option.name === '新能源' ? 'menu-group-item--new-energy' : '',
                      option.name === '燃油车' ? 'menu-group-item--gasoline': '',
                      option.enable ? 'enabled' : '',
                    ]"
                    @click.prevent.stop="optionOfHotDidPress($event, option)">
                    <span
                      v-show="option.new"
                      :class="['menu-group-item--new']">
                      new
                    </span>
                    {{ option.name }}
                  </div>
                </template>
              </div>
            </div>
            <!--/ 热门类型 -->
            <!-- Vehicle Rating -->
            <div class="menu-group condition-group">
              <div class="menu-group-hd">
                <div class="menu-group-title">车况等级</div>
              </div>
              <div class="menu-group-bd">
                <template
                  v-for="(option, optionIndex) in optionOfVehicleRating"
                  :key="optionIndex">
                  <div
                    :class="[
                      'menu-group-item',
                      option.enable ? 'enabled' : '',
                    ]"
                    @click.prevent.stop="optionOfVehicleRatingDidPress($event, option)">
                    {{ option.name }}
                  </div>
                </template>
              </div>
            </div>
            <!--/ Vehicle Rating -->
            <!-- 价格区间 START -->
            <div class="menu-group condition-group">
              <div class="menu-group-hd menu-group-hd--price-range">
                <div class="menu-group-title">
                  <span>价格区间</span>
                  <span class="unit">（万）</span>
                </div>
                <div
                  :class="[
                    'output-of-price-range',
                    outputOfPriceRange === '不限'
                      ? ''
                      : 'output-of-price-range--active',
                  ]">
                  {{ outputOfPriceRange }}
                </div>
              </div>
              <div class="menu-group-bd">
                <div class="price-range-slider-wrapper">
                  <slider
                    v-model="modelOfPriceRange"
                    :min="0"
                    :max="50"
                    :step="1"
                    :lazy="false"
                    :tooltips="false"
                    :class="['slider-el']" />
                  <div class="slider-tick-wrapper">
                    <div class="slider-tick-el slider-tick-el-0">0</div>
                    <div class="slider-tick-el slider-tick-el-10">10</div>
                    <div class="slider-tick-el slider-tick-el-20">20</div>
                    <div class="slider-tick-el slider-tick-el-30">30</div>
                    <div class="slider-tick-el slider-tick-el-40">40</div>
                    <div class="slider-tick-el slider-tick-el-50">不限</div>
                  </div>
                </div>
              </div>
            </div>
            <!--/ 价格区间 END -->

            <!-- 能源类型 -->
            <div class="menu-group condition-group">
              <div class="menu-group-hd">
                <div class="menu-group-title">能源类型</div>
              </div>
              <div class="menu-group-bd">
                <template
                  v-for="(option, optionIndex) in optionOfEnergyType"
                  :key="optionIndex">
                  <div
                    :class="[
                      'menu-group-item',
                      'menu-group-item--energy-type',
                      option.enable ? 'enabled' : '',
                    ]"
                    @click.prevent.stop="
                      optionOfEnergyTypeDidPress($event, option)
                    ">
                    {{ option.name }}
                  </div>
                </template>
              </div>
            </div>
            <!--/ 能源类型 -->

            <!-- 参考排放 -->
            <div class="menu-group condition-group">
              <div class="menu-group-hd">
                <div class="menu-group-title">参考排放</div>
              </div>
              <div class="menu-group-bd">
                <template
                  v-for="(option, optionIndex) in optionOfEmission"
                  :key="optionIndex">
                  <div
                    :class="[
                      'menu-group-item',
                      option.enable ? 'enabled' : '',
                    ]"
                    @click.prevent.stop="
                      optionOfEmissionDidPress($event, option)
                    ">
                    {{ option.name }}
                  </div>
                </template>
              </div>
            </div>
            <!--/ 参考排放 -->

            <!-- is renting battery -->
            <div class="menu-group condition-group">
              <div class="menu-group-hd">
                <div class="menu-group-title">新能源专属</div>
              </div>
              <div class="menu-group-bd">
                <template
                  v-for="(option, optionIndex) in optionOfIsRentingBattery"
                  :key="optionIndex">
                  <div
                    :class="[
                      'menu-group-item',
                      option.enable
                        ? 'enabled'
                        : '',
                    ]"
                    @click.prevent.stop="optionOfIsRentingBatteryDidPress($event, option)">
                    {{ option.name }}
                  </div>
                </template>
              </div>
            </div>
            <!--/ is renting battery -->

            <!-- 座位数 -->
            <div class="menu-group condition-group">
              <div class="menu-group-hd">
                <div class="menu-group-title">座位数</div>
              </div>
              <div class="menu-group-bd">
                <template
                  v-for="(option, optionIndex) in optionOfSeat"
                  :key="optionIndex">
                  <div
                    :class="[
                      'menu-group-item',
                      option.enable ? 'enabled' : '',
                    ]"
                    @click.prevent.stop="optionOfSeatDidPress($event, option)">
                    {{ option.name }}
                  </div>
                </template>
              </div>
            </div>
            <!--/ 座位数 -->

            <!-- 车辆形式 -->
            <div class="menu-group condition-group">
              <div class="menu-group-hd">
                <div class="menu-group-title">车辆形式</div>
              </div>
              <div class="menu-group-bd">
                <template
                  v-for="(option, optionIndex) in optionOfShape"
                  :key="optionIndex">
                  <div
                    :class="[
                      'menu-group-item',
                      option.enable ? 'enabled' : '',
                    ]"
                    @click.prevent.stop="
                      optionOfShapeDidPress($event, option)
                    ">
                    {{ option.name }}
                  </div>
                </template>
              </div>
            </div>
            <!--/ 车辆形式 -->

            <!-- drive mode -->
            <div class="menu-group condition-group">
              <div class="menu-group-hd">
                <div class="menu-group-title">驱动形式</div>
              </div>
              <div class="menu-group-bd">
                <template
                  v-for="(option, optionIndex) in optionOfDriveMode"
                  :key="optionIndex">
                  <div
                    :class="[
                      'menu-group-item',
                      option.enable ? 'enabled' : '',
                    ]"
                    @click.prevent.stop="optionOfDriveModeDidPress($event, option)">
                    {{ option.name }}
                  </div>
                </template>
              </div>
            </div>
            <!--/ drive mode -->
            <!-- 牌照归属地 -->
            <div class="menu-group condition-group">
              <div class="menu-group-hd">
                <div class="menu-group-title">牌照归属地</div>
              </div>
              <div class="menu-group-bd">
                <template
                  v-for="(option, optionIndex) in optionOfProvince"
                  :key="optionIndex">
                  <div
                    :class="[
                      'menu-group-item',
                      'menu-group-item--license-region',
                      option.enable ? 'enabled' : '',
                    ]"
                    @click.prevent.stop="
                      optionOfProvinceDidPress($event, option)
                    ">
                    {{ option.name }}
                  </div>
                </template>
              </div>
            </div>
            <!--/ 牌照归属地 -->
          </div>
          <div class="menu-section-ft">
            <div class="action-btn-wrapper">
              <div
                :class="['menu-btn', 'menu-close-btn']"
                :data-menu="'condition'"
                @click.prevent="toggleMenu">
                关闭
              </div>
              <div
                :class="['menu-btn', 'menu-clear-btn']"
                @click="clearSelectionOfConditionBtnDidPress">
                重置筛选
              </div>
              <div
                :class="['menu-btn', 'menu-submit-btn']"
                @click.prevent="submitConditionBtnDidPress">
                确认提交
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--/ condition -->

      <!-- substation -->
      <div
        v-show="activeMenu === 'substation'"
        class="menu-section-wrapper">
        <div class="menu-section">
          <div class="menu-section-hd">
            <div class="menu-section-title">
              请选择分站（多选）
            </div>
          </div>
          <div class="menu-section-bd">
            <div class="menu-group">
              <div class="menu-group-hd" />
              <div class="menu-group-bd">
                <template
                  v-for="(option, optionIndex) in optionOfSubstation"
                  :key="optionIndex">
                  <div
                    :class="[
                      'menu-group-item',
                      'menu-group--substation',
                      option.enable ? 'enabled' : '']"
                    @click.prevent="optionOfSubstationDidPress($event, option)">
                    <span
                      v-show="option.is_new"
                      :class="['menu-group-item--new']">
                      new
                    </span>
                    <template v-if="option.name === '上海站（集团总部）'">
                      <div class="menu-group--substation__title">
                        <div class="menu-group--substation__title__text">上海站</div>
                        <div class="menu-group--substation__title__desc">集团总部</div>
                      </div>
                    </template>
                    <template v-else-if="option.name === '成都站（西南中心站）'">
                      <div class="menu-group--substation__title">
                        <div class="menu-group--substation__title__text">成都站</div>
                        <div class="menu-group--substation__title__desc">西南中心站</div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="menu-group--substation__title">
                        <div class="menu-group--substation__title__text">{{ option.name }}</div>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <div class="menu-section-ft">
            <div class="action-btn-wrapper">
              <div
                :class="['menu-btn', 'menu-close-btn']"
                :data-menu="'substation'"
                @click.prevent="toggleMenu">
                关闭
              </div>
              <div
                :class="['menu-btn', 'menu-clear-btn']"
                @click="resetSubstationBtnDidPress">
                重置分站
              </div>
              <div
                :class="['menu-btn', 'menu-submit-btn']"
                @click.prevent="submitSubstationBtnDidPress">
                确认提交
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--/ substation  -->
    </div>
    <!-- 菜单 menu-bd END  -->
  </div>
  <!-- menu END -->

  <!--
    已选项目
    - brand
    - price range
    - province
    - emission (standard)
    - hot
    - seat
    - shape
    - drive mode
    - energy type
    - is renting battery
  -->

  <div
    v-show="
      brandUniqByName.length
        || outputOfPriceRange !== '不限'
        || province.length
        || energyType.length
        || emission.length
        || hot.length
        || isRentingBattery.length
        || seat.length
        || shape.length
        || driveMode.length
        || substation.length
        || vehicleRating.length"
    class="menu-selected-wrapper">
    <div class="menu-selected">
      <!-- brand -->
      <template v-if="brandUniqByName && brandUniqByName.length">
        <template
          v-for="(option, optionIndex) in brandUniqByName"
          :key="optionIndex">
          <div
            :class="['menu-selected-item']"
            @click.prevent.stop="optionOfSelectedBrandDidPress($event, option)">
            {{ option.name }}
          </div>
        </template>
      </template>
      <!--/ brand  -->

      <!-- price range -->
      <template v-if="outputOfPriceRange !== '不限'">
        <div
          :class="['menu-selected-item']"
          @click.prevent.stop="optionOfSelectedPriceRangeDidPress($event, option)">
          {{ outputOfPriceRange }}
        </div>
      </template>
      <!--/ price range -->

      <!-- province -->
      <template v-if="province && province.length">
        <template
          v-for="(option, optionIndex) in province"
          :key="optionIndex">
          <div
            :class="['menu-selected-item']"
            @click.prevent.stop="optionOfSelectedProvinceDidPress($event, option)">
            {{ option.name }}
          </div>
        </template>
      </template>
      <!--/ province -->

      <!-- energy type -->
      <template v-if="energyType && energyType.length">
        <template
          v-for="(option, optionIndex) in energyType"
          :key="optionIndex">
          <div
            :class="['menu-selected-item']"
            @click.prevent.stop="optionOfSelectedEnergyTypeDidPress($event, option)">
            {{ option.name }}
          </div>
        </template>
      </template>
      <!--/ energy type -->

      <!-- emission -->
      <template v-if="emission && emission.length">
        <template
          v-for="(option, optionIndex) in emission"
          :key="optionIndex">
          <div
            :class="['menu-selected-item']"
            @click.prevent.stop="optionOfSelectedEmissionDidPress($event, option)">
            {{ option.name }}
          </div>
        </template>
      </template>
      <!--/ emission  -->

      <!-- hot -->
      <template v-if="hot && hot.length">
        <template
          v-for="(option, optionIndex) in hot"
          :key="optionIndex">
          <div
            :class="['menu-selected-item']"
            @click.prevent.stop="optionOfSelectedHotDidPress($event, option)">
            {{ option.name }}
          </div>
        </template>
      </template>
      <!--/ hot -->

      <!-- is renting battery -->
      <template v-if="isRentingBattery && isRentingBattery.length">
        <template
          v-for="(option, optionIndex) in isRentingBattery"
          :key="optionIndex">
          <div
            :class="['menu-selected-item']"
            @click.prevent.stop="optionOfSelectedIsRentingBatteryDidPress($event, option)">
            {{ option.name }}
          </div>
        </template>
      </template>
      <!--/ is renting battery -->

      <!-- vehicle rating -->
      <template v-if="vehicleRating && vehicleRating.length">
        <template
          v-for="(option, optionIndex) in vehicleRating"
          :key="optionIndex">
          <div
            :class="['menu-selected-item']"
            @click.prevent.stop="optionOfSelectedVehicleRatingDidPress($event, option)">
            {{ option.name }}
          </div>
        </template>
      </template>
      <!--/ vehicle rating -->

      <!-- seat -->
      <template v-if="seat && seat.length">
        <template
          v-for="(option, optionIndex) in seat"
          :key="optionIndex">
          <div
            :class="['menu-selected-item']"
            @click.prevent.stop="optionOfSelectedSeatDidPress($event, option)">
            {{ option.name }}
          </div>
        </template>
      </template>
      <!--/ seat -->

      <!-- shape -->
      <template v-if="shape && shape.length">
        <template
          v-for="(option, optionIndex) in shape"
          :key="optionIndex">
          <div
            :class="['menu-selected-item']"
            @click.prevent.stop="optionOfSelectedShapeDidPress($event, option)">
            {{ option.name }}
          </div>
        </template>
      </template>
      <!--/ shape -->

      <!-- drive mode -->
      <template v-if="driveMode && driveMode.length">
        <template
          v-for="(option, optionIndex) in driveMode"
          :key="optionIndex">
          <div
            :class="['menu-selected-item']"
            @click.prevent.stop="optionOfSelectedDriveModeidPress($event, option)">
            {{ option.name }}
          </div>
        </template>
      </template>
      <!--/ drive mode -->

      <!-- substation -->
      <template v-if="substation && substation.length">
        <template
          v-for="(option, optionIndex) in substation"
          :key="optionIndex">
          <div
            :class="['menu-selected-item']"
            @click.prevent.stop="optionOfSelectedSubstationDidPress($event, option)">
            <template v-if="option.name === '上海站（集团总部）'">
              上海站
            </template>
            <template v-else-if="option.name === '成都站（西南中心站）'">
              成都站
            </template>
            <template v-else>
              {{ option.name }}
            </template>
          </div>
        </template>
      </template>
      <!--/ substation -->
    </div>
  </div>
  <!--/ 已选项目  -->
</template>

<style src="@vueform/slider/themes/default.css"></style>

<style lang="scss" scoped>
.menu {
  --menu-height: 40px;
  --menu-font-size: .9rem;
}

.menu-hd {
  width: 100%;
  height: var(--menu-height);
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  text-align: center;
  border-bottom: 1px solid var(--border-primary);
  background: var(--background);
  backdrop-filter: blur(16px);
  padding: 0 5px;
  box-sizing: border-box;
}

.menu-hd-item-wrapper {
  flex-basis: 25%;
  height: var(--menu-height);
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }

  &:last-child {
    .menu-hd-item {
      border-right: none;
    }
  }

  .menu-hd-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    color: var(--black-primary);
    border-right: 1px solid var(--border-primary);

    .menu-hd-item-text {
      font-size: var(--menu-font-size);
      position: relative;
      padding-right: 2px;
    }

    .menu-hd-item-indicator {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 5px 4px 0 4px;
      border-color:
        var(--black-primary)
        transparent
        transparent;
      margin-top: 2px;
    }

    // menu-hd-item--active
    &.menu-hd-item--active {
      .menu-hd-item-text {
         color:#ff651b !important;
      }

      .menu-hd-item-indicator {
        transform: rotate(180deg);
        border-color:
          #ff651b
          transparent
          transparent !important;
      }
    }

    // menu-hd-item--not-default
    &.menu-hd-item--not-default {
      .menu-hd-item-text {
        color:#0056b3;
      }

      .menu-hd-item-indicator {
        border-color: #0056b3 transparent transparent;
      }
    }
  }
}

.menu-section-ft {
 font-size: 1rem;
  align-items: center;
  background: var(--background);
  box-sizing: border-box;
  width: 100%;
  user-select: none;
  display: flex;
  flex-flow: row nowrap;
  padding: 0 10px 10px;
}

.action-btn-wrapper {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, .1);
  display: flex;
  flex-flow: row nowrap;
}

.menu-btn {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
}

.menu-close-btn {
  flex: 1;
  height: 50px;
  text-align: center;
  color: var(--black-primary);

  &:hover {
    filter: brightness(.9);
  }
}

.menu-clear-btn {
  flex: 2;
  height: 50px;
  text-align: center;
  color: #ff651b;
  border-left: 1px solid var(--border-primary);

  &:hover {
    filter: brightness(.9);
  }
}

.menu-submit-btn {
  flex: 2;
  height: 50px;
  text-align: center;
  background: #ff651b;
  color: #ffffff;

  &:hover {
    background: #cc651b;
  }
}

.menu-selected-wrapper {
  background: #f6f7fb;
  display: flex;
  flex-flow: row wrap;
  border-bottom: 1px solid #e6e6e6;
}

.menu-selected {
  flex: 1;
  padding: 4px 4px 0px 4px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row wrap;
}

.menu-selected-control {
  padding: 4px 0px 0px 4px;
  box-sizing: border-box;
}

.menu-selected-item,
.menu-selected .reset {
  font-size: .8rem;
  padding: 4px 5px;
  color: #666666;
  border: 1px solid #e0e0e0;
  margin-right: 5px;
  background: var(--background);
  box-sizing: border-box;
  line-height: 1;
}

.menu-selected .reset {
  color: #53a949;
  box-sizing: border-box;
  font-size: .8rem;
}

.menu-selected-item {
  margin-bottom: 4px;
  user-select: none;

  &:hover {
    cursor: pointer;
  }

  &:last-child {
    margin-right: 0;
  }
}

.menu-selected-item:after {
  content: '\00d7';
  margin-left: 4px;
  margin-top: -1px;
  display: inline-block;
}

/* bd general */
.menu-bd-wrapper {
  height: calc(100vh - 40px - 1px - var(--navigation-height));
  width: 100%;
  box-sizing: border-box;
  // padding: 10px;
}

.menu-section-wrapper {
  // height:
  // height: -webkit-fill-available;
  height: calc(100dvh - var(--navigation-height) - 40px);
  box-sizing: border-box;
}

.menu-section {
  height: 100%;
}

.menu-section {
  display: flex;
  flex-flow: column nowrap;
}

.menu-group {
  padding: 0 10px;
}

.menu-section-hd {
  margin-top: 10px;
  padding: 0 10px;
}

.menu-section-hd .menu-section-title {
  font-size: .75rem;
  line-height: 1.225;
  color: #656565;
  margin-bottom: 2px;
}

.menu-section-bd {
  padding: 0;
  flex: 1;
  overflow: scroll;
}

.menu-group-hd {
  margin: 5px 0 8px 0;
}

.menu-group-title {
  font-size: .9rem;
  color: #010101;
}

.menu-group.menu-group.condition-group .menu-group-title {
  color: var(--black-primary);
  padding: 2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 0.8rem;
  font-weight: bold;
}

.menu-group.sort-menu-group {
  border-bottom: none;
  // padding: 0;
  margin: 0;
}

.sort-menu-group-bd {
  padding: 0;
  margin: 0;
}

.menu-group-bd {
  display: flex;
  flex-flow: row wrap;
}

.menu-group-bd.menu-group-bd--brand {
  flex-flow: column nowrap;
}

.menu-group.condition-group {
  margin-bottom: 10px;
}

.menu-group-item {
  flex-basis: 32%;
  margin-right: calc(4% / 3);
  margin-bottom: calc(4% / 3);
  padding: 10px 0;
  box-sizing: border-box;
  font-size: .8rem;
  text-align: center;
  color: var(--black-primary);
  border-radius: 2px;
  user-select: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F2F2F2;
  border: 1px solid #F2F2F2;
}

/* menu group item -- sort */
.menu-group-item.menu-group-item-sort {
  flex-basis: 100%;
  margin: 5px 0;
  padding: 10px 0;
  box-sizing: border-box;
}

.menu-section-wrapper--condition .menu-group-item {
  flex-basis: calc(100% / 5 - 10px * 4 / 5);
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 6px 0;
}

.menu-section-wrapper--condition .menu-group-item:nth-child(5n) {
  margin-right: 0;
}

.menu-group-item.menu-group--substation {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-basis: calc(50% - 5px);
  margin-right: 10px;
  margin-bottom: 10px;
  min-height: 50px;
}

.menu-group-item.menu-group--substation:nth-child(2n) {
  margin-right: 0;
}

// 2024.10.14
// Energy Type
.menu-group-item.menu-group-item--energy-type {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-basis: calc(100% / 3 - 10px / 2 * 3);
  margin-right: 10px;
  margin-bottom: 10px;
}

.menu-group-item.menu-group-item--energy-type:nth-child(3n) {
  margin-right: 0;
}

.menu-group-item.menu-group-item--license-region {
  flex-basis: calc(100% / 5 - 5px * 4 / 5);
  margin-right: 5px;

  &:nth-child(4n) {
    margin-right: 5px;
  }

  &:nth-child(5n) {
    margin-right: 0;
  }
}

.menu-group-item--new {
  padding: 1px 2px;
  border-radius: 2px;
  box-sizing: border-box;
  display: inline;
  font-size: .7rem;
  line-height: 1;
  font-weight: 700;
  background-color: #cf222e;
  color: white;
  margin-right: 4px;
  display: inline-block;
  vertical-align: middle;
}

.menu-group-item.menu-group-item--new-energy {
  color: #212121;
  background: rgb(102,175,136);
  background: linear-gradient(0deg, rgba(102,175,136,1) 0%, rgba(137,202,168,1) 30%, rgba(255,255,255,1) 100%);
}

.menu-group-item.enabled {
  background: var(--background);
  color: #ff7f32;
  border: 1px solid #ff7f32;
  background: #FFF1EA;
}

.menu-group-item.menu-group-item--new-energy.enabled {
  color: #212121;
  background: rgb(102,175,136);
  background: linear-gradient(0deg, rgba(102,175,136,1) 0%, rgba(137,202,168,1) 30%, rgba(255,255,255,1) 100%);
  border: 1px solid #ff7f32;
}

// menu-group-item--gasoline
// - 2024.10.21
.menu-group-item.menu-group-item--gasoline {
  background: #026bcc;
  color: #ffffff;
  border-color: #026bcc;
}

.menu-group-item.menu-group-item--gasoline.enabled {
  border: 1px solid #ff7f32;
}

.menu-group.menu-brand-group {
  flex-flow: row wrap;
  border-bottom: none;
}

.menu-group-item.menu-group-item--brand {
  --margin: 6px;
  --per-row: 5;
  flex-flow: column nowrap;
  flex-basis: calc(100% / 6 - 6px  * 5 / 6);
  margin-right: 6px;
  margin-bottom: 6px;
  padding: 5px;
  box-sizing: border-box;
  overflow: visible;
  position: relative;
  background: #F2F2F2;

  &:nth-child(6n) {
    margin-right: 0;
  }
}

.menu-group-item--brand__icon--new-energy {
  opacity: .5;
  z-index: 200;
  position: absolute;
  top: -4px;
  right: -4px;
  width: 15px;
  height: 25px;
  background: transparent url(https://static.nuonuo.com.cn/zycmp/standard-list-filter-brand-item-icon-new-energy-20240618-03.png) center no-repeat;
  background-size: 100%;
}

.menu-group-item.menu-group-item--brand::before {
  content:'';
  display: none;
}

.menu-group-item.menu-group-item--brand.empty::before {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 200;
  background-color: rgba(200, 200, 200, .3);
}

.menu-group-item.menu-group-item--brand
  .brand-item-pic-wrapper {
  width: 100%;
  position: relative;
  z-index: 100;
  overflow: hidden;
  background: #FFFFFF;
  margin-bottom: 4px;
}

.brand-item-pic-wrapper::before {
  content: '';
  display: block;
  padding-bottom: 100%;
  width: 100%;
}

.brand-item-pic-wrapper .brand-item-pic {
  position: absolute;
  width: 80%;
  height: 80%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  object-fit: contain;
  background: #FFFFFF;
}

.brand-item-name-wrapper {
  font-size: .75rem;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.brand-item-name__text {
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 1 auto;
  max-width: 40px;
  color: var(--black-primary);
}

.brand-item-name__count {
  white-space: nowrap;
  flex: 0;
}

// 2021.12.27 价格区间
.menu-group-hd.menu-group-hd--price-range {
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 10px;
}

.menu-group-hd.menu-group-hd--price-range .menu-group-title {
  flex: 1;
}

.slider-el {
  --slider-bg: #f0f0f0;
  --slider-connect-bg: #ff651b;
}

.price-range-slider-wrapper {
  width: 100%;
  padding: 10px 25px;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.output-of-price-range {
  margin-left: auto;
  padding-right: 20px;
  padding-left: 15px;
  box-sizing: border-box;
  font-size: .9rem;
}

.output-of-price-range {
  color: #999999;
}

.output-of-price-range.output-of-price-range--active {
  color: #ff651b;
}

.slider-tick-wrapper {
  width: 100%;
  max-width: 100%;
  padding-top: 8px;
  box-sizing:border-box;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  color: #909090;
  position: relative;

  .slider-tick-el {
    box-sizing: border-box;
    width: 40px;
    text-align: center;

    &.slider-tick-el-0 {
      text-align: left;
    }

    &.slider-tick-el-10 {
      position: absolute;
      left: calc(20% - (40px / 2));
    }

    &.slider-tick-el-20 {
      position: absolute;
      left: calc(40% - (40px / 2));
    }

    &.slider-tick-el-30 {
      position: absolute;
      left: calc(60% - (40px / 2));
    }

    &.slider-tick-el-40 {
      position: absolute;
      left: calc(80% - (40px / 2));
    }

    &.slider-tick-el-50 {
      position: absolute;
      left: calc(100% - 40px);
    }
  }
}

.menu-selected-wrapper:empty {
  display: none;
  .menu-selected:empty {
    display: none;
  }
}

.selected-brand-item {
  color: #0056b3;
  margin-right: 5px;
}

.brand__selected-substations-wrapper {
  // margin-top: 5px;
  display: flex;
  flex-flow: row nowrap;
}

.menu-group--substation__title {
  // .menu-group--substation__title__text {}
  .menu-group--substation__title__desc {
    color: #606060;
    font-size: .75rem;
  }
}

.menu-group-item.menu-group--substation.enabled .menu-group--substation__title {
  // .menu-group--substation__title__text {}
  .menu-group--substation__title__desc {
    color: #ff7f32;
  }
}

.brand-group-wrapper {
  margin-bottom: 10px;
}

.brand-group-hd {
  margin-bottom: 6px;
}

.brand-group-title {
  color: var(--black-primary);
  padding: 2px;
  box-sizing: border-box;
  font-size: .85rem;
  font-weight: bold;
}

.brand-group-bd {
  display: flex;
  flex-flow: row wrap;
}

@media (min-width: 740px) {
  .menu-group-item.menu-group-item--brand {
    flex-basis: calc(100% / 8 - 10px / 8 * 7);
    margin-right: 10px;
    margin-bottom: 10px;

    padding: 5px;
    box-sizing: border-box;
    position: relative;

    &:nth-child(6n) {
      margin-right: 10px;
    }

    &:nth-child(8n) {
      margin-right: 0;
    }

    .brand-item-text {
      font-size: .9rem;
    }
  }

  // condition
  .menu-group.condition-group {
    flex-basis: calc(100% / 5 - 10px * 4 / 5);
    // margin-right: 10px;
    // padding: 8px 0;
  }

  .menu-group.condition-group .menu-group-item:nth-child(5n) {
    margin-right: 0;
  }

  // substation
  .menu-group-item.menu-group--substation {
    --margin: 10px;
    --per-row: 5;
    flex-basis: calc(100% / 3 - 10px * 2 / 3);
    margin-right: 10px;
  }

  .menu-group-item.menu-group--substation:nth-child(2n) {
    margin-right: 10px;
  }

  .menu-group-item.menu-group--substation:nth-child(3n) {
    margin-right: 0;
  }

  .brand-item-name__text {
    max-width: 50px;
    font-size: 12px;
  }

  .brand-group-wrapper {
    // padding: 0 10px;
  }

  // 2024.10.14
  // Energy Type
  .menu-group.condition-group .menu-group-item.menu-group-item--energy-type {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-basis: calc(100% / 3 - 10px * 2 / 3);
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .menu-group.condition-group .menu-group-item.menu-group-item--energy-type:nth-child(3n) {
    margin-right: 0;
  }
}

@media (prefers-color-scheme: dark) {
  .menu-group-item,
  .menu-group-item.menu-group-item--brand {
    background: #1A1A1A;
    border: 1px solid #1A1A1A;
  }

  .menu-group-item.enabled {
    background: #632100;
    border-color: #9A3300;
    color: #FFFFFF;
  }

  .brand-group-title {
    background: #1A1A1A;
  }

  .menu-clear-btn,
  .menu-close-btn {
    background: #272727;
  }

  .menu-group.menu-group.condition-group .menu-group-title {
    // background: #1A1A1A;
  }

  .menu-selected-wrapper {
    background: #0F0F0F;
    border-color: #272727;
  }

  .menu-selected-item {
    border: none;
    background: #272727;
    color: #F0F0F0;
  }
}

</style>

